import React from "react";

const SvgBook = props => (
  <svg
    id="book_svg___6062_-_Read_Book"
    width="1em"
    height="1em"
    data-name="6062 - Read Book"
    viewBox="0 0 300.512 311.391"
    {...props}
  >
    <defs>
      <style>{".book_svg__cls-1{fill:#fff}"}</style>
    </defs>
    <g id="book_svg__Layer_x0020_1" transform="translate(45.008 43.789)">
      <g id="book_svg___434840096">
        <path
          id="book_svg___434841248"
          d="M128.524 138.869v13.1q-.725.291-1.435.638l-.244.121H84.017v-13.859H1.022V1.361h18.3v9.484h-9.147v118.54H93.17v13.865h26.2v-13.865h21.33c.023 3.162.083 6.322.146 9.484h-12.322zm49.574-9.484h24.269V10.845h-9.152V1.361h18.3v137.508h-25.86a77.997 77.997 0 00-6.98-2.129l-.581-7.355z"
          className="book_svg__cls-1"
          transform="translate(-1.022 16.929)"
        />
        <path
          id="book_svg___434840048"
          d="M4.173 9.842A95.886 95.886 0 0146.971.983c14.265.3 28.574 3.506 42.913 8.71l3.075 1.116v129.353H1.438V11.1l2.735-1.26zm42.619.588a87.228 87.228 0 00-36.2 6.837v113.411h73.215V17.538C71.353 13.281 59 10.689 46.792 10.43z"
          className="book_svg__cls-1"
          transform="translate(16.866 -.96)"
        />
        <path
          id="book_svg___434839856"
          d="M85.677 17.267a87.228 87.228 0 00-36.2-6.837c-12.209.259-24.561 2.851-37.014 7.108v113.14H42.7a195.646 195.646 0 00-.367 9.484H3.309V10.809l3.075-1.116C20.723 4.489 35.032 1.286 49.3.984a95.886 95.886 0 0142.8 8.858l2.73 1.258v129.06H79.15l-.749-9.484h7.277V17.267z"
          className="book_svg__cls-1"
          transform="translate(97.363 -.96)"
        />
        <path
          id="book_svg___434839904"
          d="M6.631 6.5A4.777 4.777 0 003.9 12.559a4.521 4.521 0 005.845 2.834 64.969 64.969 0 0121.688-4.247c8.492-.226 18.429 1 30.49 4.376a4.556 4.556 0 005.595-3.352 4.755 4.755 0 00-3.236-5.8C51.369 2.763 40.573 1.451 31.214 1.7A73.633 73.633 0 006.631 6.5z"
          className="book_svg__cls-1"
          transform="translate(110.791 30.724)"
        />
        <path
          id="book_svg___434839736"
          d="M6.631 6.918A4.777 4.777 0 003.9 12.975a4.521 4.521 0 005.845 2.834 64.969 64.969 0 0121.688-4.247c8.492-.226 18.429 1 30.49 4.376a4.556 4.556 0 005.595-3.352 4.755 4.755 0 00-3.236-5.8c-12.909-3.609-23.7-4.922-33.063-4.673a73.633 73.633 0 00-24.583 4.8z"
          className="book_svg__cls-1"
          transform="translate(110.791 49.275)"
        />
        <path
          id="book_svg___434840264"
          d="M6.631 7.333A4.777 4.777 0 003.9 13.39a4.521 4.521 0 005.845 2.834 64.973 64.973 0 0121.688-4.247c8.492-.226 18.429 1 30.49 4.377A4.556 4.556 0 0067.513 13a4.755 4.755 0 00-3.236-5.8C51.369 3.594 40.573 2.282 31.214 2.53a73.629 73.629 0 00-24.583 4.8z"
          className="book_svg__cls-1"
          transform="translate(110.791 67.792)"
        />
        <path
          id="book_svg___434840312"
          d="M87.292 59.665a7.327 7.327 0 011.14 2.805l.006.033v.018c.262 1.439 4.462 24.989-6.784 39.148A26.835 26.835 0 0162 111.835c-8.568.653-17.65-2.042-24.88-6.015h-.02a72.68 72.68 0 01-8.347-5.437 96.362 96.362 0 01-8.281-6.98h-.018A121.4 121.4 0 015.093 75.794l-.014-.021-.018-.018a7.462 7.462 0 01-1.3-4.653 7.372 7.372 0 011.828-4.458l-.01-.009a19.275 19.275 0 015.992-4.686 16.183 16.183 0 017.199-1.669 18.792 18.792 0 017.03 1.445 22.639 22.639 0 012.328 1.1l.016-3.132c.063-12.653.141-28.165.141-43l.018-.241a13.825 13.825 0 014.074-9.21 12.823 12.823 0 0118.308.178 13.9 13.9 0 013.937 9.205h.009l2.292 29.01A74 74 0 0167.4 48.658a99.914 99.914 0 0117.737 8.926l.018.018a7.179 7.179 0 012.132 2.063zm-7.665 5.522a89.389 89.389 0 00-15.3-7.639 70.592 70.592 0 00-10.391-2.9h-.018l-.827-.184a68.85 68.85 0 01-1.469-.326l-3.266-.781-.269-3.457-2.571-32.532v-.3a4.269 4.269 0 00-1.228-2.907 3.985 3.985 0 00-5.617-.067 4.24 4.24 0 00-1.232 2.6c0 7.762-.1 27.18-.177 43.034-.022 4.49-.044 8.662-.06 12.221l-.043 9.567-7.3-5.844-3.281-2.625-.178-.147a14.4 14.4 0 00-3.919-2.363 9.948 9.948 0 00-3.707-.777 7.412 7.412 0 00-3.3.743 8.962 8.962 0 00-1.9 1.269A114.6 114.6 0 0026.6 86.4l-.008.009a87.063 87.063 0 007.484 6.3 63.363 63.363 0 007.31 4.733v.008c5.9 3.242 13.214 5.448 19.968 4.933a18.057 18.057 0 0013.258-6.721c7.641-9.622 5.67-26.224 5.015-30.48z"
          className="book_svg__cls-1"
          transform="translate(116.445 111.879)"
        />
        <path
          id="book_svg___434840408"
          d="M6.631 7.749A4.777 4.777 0 003.9 13.806a4.521 4.521 0 005.845 2.834 64.974 64.974 0 0121.688-4.247c8.492-.226 18.429 1 30.49 4.377a4.556 4.556 0 005.595-3.353 4.755 4.755 0 00-3.236-5.8C51.369 4.01 40.573 2.7 31.214 2.946a73.628 73.628 0 00-24.583 4.8z"
          className="book_svg__cls-1"
          transform="translate(110.791 86.343)"
        />
      </g>
    </g>
    <path
      id="book_svg__Rectangle_18"
      d="M0 0h300.512v311.39H0z"
      data-name="Rectangle 18"
      fill="none"
    />
  </svg>
);

export default SvgBook;

